import { styled, Typography, Grid } from '@material-ui/core'
import { Form as BaseForm } from 'formik'
import { FormikTextfield as BaseTextField } from 'shared/components'

const INPUT_HEIGHT = 50

export const TextField = styled(BaseTextField)({
  '& fieldset': {
    top: 0,
  },
  '& .MuiInputBase-root': {
    height: INPUT_HEIGHT,
  },
})

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  lineHeight: '28px',
  fontSize: 24,
  marginBottom: theme.spacing(4),
}))

export const Form = styled(BaseForm)({
  width: '100%',
})

export const PaymentMethodWrapper = styled('div')(({ theme }) => ({
  margin: theme.spacing(0, 1, 1, 0),
}))

export const PaymentMethodsWrapper = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}))
